<template>
  <div class="interview-checkIn">
    <template v-if="lists.length > 0">
      <div v-for="item in lists" :key="item.id" class="interview-item">
        <div class="interview-item-info">
          <p class="interview-item-info-title text-hide">
            {{ item.candidate.jobPosition.title }}
          </p>
          <p class="interview-item-info-time">
            {{ $moment(item.interviewedAt + 'Z').format('YYYY-MM-DD HH:mm') }}
          </p>
        </div>
        <div>
          <Button
            type="primary"
            shape="circle"
            :loading="item.sbLoading"
            :disabled="item.checkInFlag"
            @click="onCheckIn(item)"
            ghost
          >
            {{
              $t(
                `interview.checkIn.${item.checkInFlag ? 'signedIn' : 'checkIn'}`
              )
            }}
          </Button>
        </div>
      </div>
    </template>
    <div class="interview-nodata" v-else>
      <div class="interview-nodata-info">
        <p class="interview-nodata-info-title">
          {{ $t('interview.checkIn.noData.title') }}
        </p>
        <p class="interview-nodata-info-time">
          {{ $t('interview.checkIn.noData.content') }}
        </p>
      </div>
      <Button
        long
        type="primary"
        @click="
          $router.push(
            `/interview/signedQR/verify?teamId=${$route.query.teamId}&interviewName=${$route.query.interviewName}`
          )
        "
      >
        {{ $t('interview.verify.restVerify') }}
      </Button>
    </div>
  </div>
</template>
<script>
import app_config from '@/commons/app_config';
import { mapState } from 'vuex';
export default {
  data() {
    return {
      sbLoading: false,
      formValidate: {
        teamId: this.$route.query.teamId,
        interviewIds: []
      }
    };
  },
  created() {
    document.title = this.$t('interview.checkIn.name');
  },

  computed: {
    ...mapState({
      lists: (state) => state.interviews
    })
  },
  methods: {
    async onCheckIn(item) {
      try {
        this.formValidate.interviewIds = [item.id];
        this.$set(item, 'sbLoading', true);
        let url = `${app_config.mainApiEndpoint}/rest/api/v1/self/recruitment/interview/check_in`;
        await this.$http('POST', url, this.formValidate, true);
        this.$set(item, 'checkInFlag', true);
        this.$Message.success(this.$t('interview.checkIn.success'));
      } finally {
        this.$set(item, 'sbLoading', false);
      }
    }
  }
};
</script>
<style lang="less">
.interview-checkIn {
  background: #f8f9fa;
  height: 100vh;
  .interview-item {
    display: flex;
    padding: 12px;
    align-items: center;
    box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.06);
    border-radius: 6px;
    background: #fff;
    margin: 8px;
  }
}
.interview-nodata {
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 32px;
  height: 100vh;
  .interview-nodata-info {
    margin-bottom: 16px;
    align-items: center;
    display: flex;
    flex-direction: column;
  }
  .interview-nodata-info-title {
    margin-bottom: 16px;
  }
}
.interview-item-info {
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: start;
}
.interview-item-info-title,
.interview-nodata-info-title {
  color: #1c2438;
  font-size: 16px;
  max-width: 150px;
  line-height: 1;
}
.interview-item-info-time,
.interview-nodata-info-time {
  color: #80848f;
  line-height: 22px;
  text-align: left;
}
</style>
